<template>
  <div class="setup-content">
    <ContentBasicsForm :contentOwnership="contentOwnership" />
    <ContentLauncherForm :contentOwnership="contentOwnership" />
    <ContentLanguageForm :contentOwnership="contentOwnership" @updateLanguage="onUpdateLanguage" />
    <ContentDiscoverableForm
      v-if="!$permissions['enterprise-developer']"
      :contentOwnership="contentOwnership"
    />
  </div>
</template>

<script>
import ContentBasicsForm from './content-fields/ContentBasicsForm';
import ContentLanguageForm from './content-fields/ContentLanguageForm';
import ContentLauncherForm from './content-fields/ContentLauncherForm';
import ContentDiscoverableForm from './content-fields/ContentDiscoverableForm';

export default {
  name: 'SetupContent',
  components: {
    ContentBasicsForm,
    ContentLanguageForm,
    ContentLauncherForm,
    ContentDiscoverableForm,
  },
  props: {
    contentOwnership: {
      type: Object,
      required: true,
    },
  },
  setup (props) {
    return {
      onUpdateLanguage (val) {
        props.contentOwnership.contentOwnershipLanguages = val;
      },
    };
  },
};
</script>
